<template>
  <router-view />
</template>

<script>
export default {
  name: 'SchemesEditContactsRouter',
};
</script>
